export default __webpack_public_path__ + "static/media/drag-your-images-here.3f1b4a39.svg";